import { Container, Grid, Paper } from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import React from "react";

import BlockedPeriods from "./BlockedPeriods";
import DefaultAvailability from "./DefaultAvailability/DefaultAvailability";
import DefaultSessionLengthsAndBreaks from "./DefaultSessionLengthsAndBreaks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      marginTop: theme.spacing(3),
      padding: theme.spacing(2),
      textAlign: "left",
      color: theme.palette.text.secondary,
      "& h6": {
        fontSize: "14px",
        lineHeight: "16px",
        marginTop: theme.spacing(3),
      },
      "& p": {
        color: "#525252",
        fontSize: "15px",
        lineHeight: "18px",
      },
      "& span": {
        display: "block",
        width: "100%",
        color: theme.palette.text.secondary,
        fontSize: "16px",
        lineHeight: "20px",
        "& svg": {
          float: "right",
        },
      },
    },
    actions: {
      marginTop: theme.spacing(2),
      "& section": {
        marginTop: "5px",
        marginBottom: "5px",
        textAlign: "left",
        color: theme.palette.text.secondary,
        "& p": {
          color: theme.palette.text.primary,
          fontSize: "17px",
          lineHeight: "20px",
          paddingLeft: theme.spacing(2),
        },
        "& span": {
          color: theme.palette.text.secondary,
          fontSize: "17px",
          lineHeight: "20px",
          marginLeft: -25,
        },
        "& svg": {
          float: "right",
          fill: "#D0021B",
          marginRight: 15,
        },
      },
      "& button": {
        marginTop: 5,
        height: 56,
        fontSize: 17,
        whiteSpace: "nowrap",
        textTransform: "none",
        padding: "0 30px",
        backgroundColor: "var(--text-primary)",
        "& svg": {
          marginLeft: "calc(100% - 110px)",
        },
        "&:hover": {
          backgroundColor: "var(--text-primary)",
        },
      },
    },
  })
);

const AvailabilitySettingsPage: React.FC = () => {
  const classes = useStyles();
  return (
    <div id="Availability">
      <Grid container>
        <Grid item xs={12} md={8}>
          <Paper className={classes.paper}>
            <DefaultAvailability />
            <DefaultSessionLengthsAndBreaks />
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Container className={classes.actions}>
            <BlockedPeriods />
          </Container>
        </Grid>
      </Grid>
    </div>
  );
};

export default AvailabilitySettingsPage;
